// removed by extract-text-webpack-plugin
module.exports = {"promoContainer":"VerifiedTradePromo__promoContainer__1VryM","textContainer":"VerifiedTradePromo__textContainer__1NKgf","highlightedText":"VerifiedTradePromo__highlightedText__X9b42","infoContainer":"VerifiedTradePromo__infoContainer__3gRRS","infoIcon":"VerifiedTradePromo__infoIcon__QyiGT","tooltip":"VerifiedTradePromo__tooltip__l2AG1","top":"VerifiedTradePromo__top__2mGbV","left":"VerifiedTradePromo__left__20ptO","tooltipInner":"VerifiedTradePromo__tooltipInner__1OKiE","inShippingModal":"VerifiedTradePromo__inShippingModal__2AFj3"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/VerifiedTradePromo.scss
// module id = 1256
// module chunks = 4 14